const $ = jQuery;
const $window = $(window);

const initSlider = () => {
  const els = once('main-image-slider', '.p-main-slider');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $slider = $wrapper.find('.pms-slider');
    const $sliderVideoOverlay = $wrapper.find('.pms-video-overlay');
    const $sliderVideo = $wrapper.find('#om-video-embed');
    const $videoPlayBtn = $wrapper.find('.pms-play-btn');
    const $videoCloseBtn = $wrapper.find('.pms-video-close');
    const $sliderVideoSrc = $sliderVideo.attr('src');

    let url;
    if ($sliderVideoSrc) {
      url = new URL($sliderVideoSrc);
    }

    $slider.slick({
      slidesToShow: 1,
      dots: true,
      accessibility: true,
      pauseOnHover: true,
      autoplaySpeed: 3000,
      prevArrow: $wrapper.find('.om-slider-arrow-prev'),
      nextArrow: $wrapper.find('.om-slider-arrow-next'),
      appendDots: $wrapper.find('.pms-dots'),
    });

    $videoPlayBtn.on('click', function () {
      $sliderVideoOverlay.css('display', 'flex');
      url.searchParams.set('autoplay', '1');
      $sliderVideo.attr('src', url.toString());
    });

    $videoCloseBtn.on('click', function () {
      $sliderVideoOverlay.css('display', 'none');
      url.searchParams.set('autoplay', '0');
      $sliderVideo.attr('src', url.toString());
    });
  });
};

$window.on('load', function () {
  initSlider();
});
